<div class="px-4 sm:px-6 lg:px-8">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-base font-semibold leading-6 text-gray-900">Registro de OTs</h1>
      <p class="mt-2 text-sm text-gray-700">
        Estás visualizando todas las <strong class="font-semibold text-gray-900">OTs</strong>.
      </p>
    </div>
    <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
      <button routerLink="create/new" type="button" class="block rounded-md primary-button px-3 py-2 text-center text-sm font-semibold text-white shadow-sm">
        Crea una nueva OT
      </button>
    </div>
  </div>
  <div class="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-300">
      <thead>
        <tr>
          <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Nº OT</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Cliente</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Denominación</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">MC</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Pedido/Solicitud</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Comienzo</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Gamas</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Plazo de entrega</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Entrega</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Nueva Entrega</th>
          <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell">Valoración</th>
          <th scope="col" class="relative min-w-[320px] py-3.5 pl-3 pr-4 sm:pr-6">
            <span class="sr-only">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of orders">
          <td class="relative py-4 pl-4 pr-3 text-sm sm:pl-6">
            <div class="font-medium text-gray-900">{{order.number}}</div>
            <div class="mt-1 flex flex-col text-gray-500 sm:block xl:hidden">
              <span>{{ getActiveGamas(order).length }} gamas</span>
              <span class="hidden sm:inline px-1">{{ order.deliver_date ? '·' : '' }}</span>
              <span>{{order.deliver_date ? dateService.formatDate(order.deliver_date) : ''}}</span>
            </div>
          </td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.client}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.denomination}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.mc ? 'Sí' : 'No'}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.request ? order.request : '-'}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.start_date ? dateService.formatDate(order.start_date) : '-'}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{getActiveGamas(order).length}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.deliver_date ? dateService.formatDate(order.deliver_date) : '-'}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.delivery ? dateService.formatDate(order.delivery) : '-'}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.new_deliver_date ? 'X' : ''}}</td>
          <td class="hidden px-3 py-3.5 text-sm text-gray-500 xl:table-cell">{{order.review_date ? dateService.formatDate(order.review_date) : '-'}}</td>
          <td class="relative min-w-[320px] py-3.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
            <div class="flex flex-wrap gap-2 justify-end">
              <button routerLink="edit/{{order.id}}" type="button" class="shrink-0 whitespace-nowrap inline-flex justify-center items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
                Editar
              </button>
              <button (click)="cloneOrder(order)" type="button" class="shrink-0 whitespace-nowrap inline-flex justify-center items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
                Clonar
              </button>
              <button (click)="openDeleteModal(order)" type="button" class="shrink-0 whitespace-nowrap inline-flex justify-center items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
                Eliminar
              </button>
              <button routerLink="view/{{order.id}}" type="button" class="shrink-0 whitespace-nowrap inline-flex justify-center items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
                Consultar
              </button>
              <button *ngIf="getActiveGamas(order).length > 0" (click)="generateGamasPDF(order)" type="button" class="shrink-0 whitespace-nowrap inline-flex justify-center items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
                Imprimir gamas
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<!-- 

  Delete Modal
  
-->
<div *ngIf="modal" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div>
          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
              Borrar OT {{delete_order.number}}
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                ¿Estás seguro que quieres eliminar la OT {{delete_order.number}}?
                <br>
                <span class="italic underline">Esta acción no se puede deshacer.</span>
              </p>
            </div>
          </div>

          <fieldset class="mt-3 flex justify-center">
            <legend class="sr-only">Notifications</legend>
            <div class="space-y-5">
              <div class="relative flex items-start">
                <div class="flex h-6 items-center">
                  <input [(ngModel)]="modal_delete_checkbox" id="delete_modal_checkbox" aria-describedby="delete_modal_checkbox" name="delete_modal_checkbox" type="checkbox" class="h-4 w-4 rounded border-gray-300 primary-text-color focus:primary-ring-color">
                </div>
                <div class="ml-3 text-sm leading-6">
                  <label for="comments" class="font-medium text-gray-900">Confirmo que quiero eliminar la OT {{ delete_order.number }}</label>
                  <!-- <span id="comments-description" class="text-gray-500">Identificado como {{firebaseService.user.email}}</span> -->
                </div>
              </div>
            </div>
          </fieldset>

        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense {{ modal_delete_checkbox ? 'sm:grid-cols-2' : '' }} sm:gap-3">
          <button *ngIf="modal_delete_checkbox" (click)="deleteOrder()" type="button" class="primary-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:col-start-2">
            Confirmar
          </button>
          <button (click)="closeDeleteModal()" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
